import { useDispatch, useSelector } from "react-redux";
import { KendoGrid, RefreshKendoGrid } from "../../Kendo/kendo_grid";
import { useEffect, useState } from "react";
import ReportDropdown from "./ReportDropdown";
import { baseURL, fetch, post } from "../../Util/axios_helper";
import {
  Button,
  ErrorMsg,
  GetFormData,
  ValidateForm,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import { UrlForCOL, UrlForCS, UrlForSMS, onUrlchanged } from "./ReportSlice";
export default function Report() {
  const {
    countsReportData,
    countsReportDataLoaded,
    userFilterData,
    refresh,
    url,
    UrlCS,
    UrlSms,
    UrlForCallLog,
    CS,
    Sms,
    callLog,
    Reset
  } = useSelector((state) => state.reportData);
  const [data, setData] = useState();
  const [showFirstGrid, setShowFirstGrid] = useState(true);
  const [showSecondGrid, setShowSecondGrid] = useState(false);
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const [event, setEvent] = useState({
    Name: "",
    Description: "",
  });

  useEffect(() => {
    if (
      countsReportData &&
      countsReportData != undefined &&
      countsReportData.length > 0
    ) {
      setData(countsReportData);
    } else if (
      userFilterData &&
      userFilterData != undefined &&
      userFilterData.length > 0
    ) {
      setData(userFilterData);
    }
  }, [countsReportData, userFilterData]);

  useEffect(() => {}, [url, event]);

  const handleEditClick = async (e) => {
    setEvent({
      FilterId: e.FilterId,
      Name: e.Name,
      Description: e.Description,
      Report: e.Report,
      Filters: e.Filters,
    });

    $("#update-Filter").modal("show");
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      fetch(
        `Report/ReportFilterDelete?FilterId=${e.FilterId}`,
        true,
        false,
        true
      ).then(() => {
        RefreshKendoGrid("UserSavedFilter");
      });
    };
    confirmDelete(onDelete);
  };

  const Generate = (e) => {
    let selectedReport = $(e).data("id");
    let url = $(e).data("type");

    const controllerActionName =
      selectedReport && selectedReport == "Revenue"
        ? ""
        : selectedReport == "Sales"
        ? ""
        : selectedReport == "Counts On Lead Status"
        ? "Report/CountsOnLead_Report?"
        : selectedReport == "Customer Satisfaction"
        ? "Report/Customersatisfication_Report?"
        : selectedReport == "RingCentral SmsLog"
        ? "Report/RingCentralSMSLog_Reports?"
        : selectedReport == "RingCentral CallLog"
        ? "Report/RingCentralCallLog_Report?"
        : "";

    const fullUrl = baseURL + controllerActionName + url;
   
    if (selectedReport == "Counts On Lead Status") {
      dispatch(UrlForCOL(fullUrl));
    } else if (selectedReport == "Customer Satisfaction") {
      dispatch(UrlForCS(fullUrl));
    } else if (selectedReport == "RingCentral SmsLog") {
      dispatch(UrlForSMS(fullUrl));
    } else if (selectedReport == "RingCentral CallLog") {
      dispatch(UrlForCallLog(fullUrl));
    }
  };

  const clearForm = () => {
    setError({});
    $("#btn-reset").click();
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else {
      let Formdata = GetFormData(e);
      Formdata.UserId = sessionUser();

      await post("Report/InterUpdateFilter", Formdata);
      RefreshKendoGrid("UserSavedFilter");
      $("#update-Filter").modal("hide");
      clearForm();
    }
  };

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Reports</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="index.html">Reports</a>
              </li>
              <li className="breadcrumb-item active">Reports</li>
            </ul>
          </div>
        </div>
      </div>
      <ReportDropdown
        CountsOnLeadReport={true}
        IsCountsfilter={true}
        IsReport={true}
      ></ReportDropdown>

      {!refresh && !CS && !Sms && !callLog && (
        <KendoGrid
          name={"UserSavedFilter"}
          schema={{}}
          url={baseURL + "Report/GetUserReportFilter?UserId=" + sessionUser()}
          columns={[
            {
              field: "FilterId",
              title: "FilterId",
              hidden: true,
            },
            {
              field: "Filters",
              title: "Filters",
              hidden: true,
            },
            {
              field: "",
              title: "",
              template: function (e) {
                var fileLinks = "";
                fileLinks += `
                  <div style="text-align: center;">
                    <button class="generate" data-id="${e.Report}" data-type="${e.Filters}"
                      style="font-size: 15px; color: white; background-color: green; border: none; cursor: pointer; padding: 2px 10px;border-radius: 10px;">
                      Generate
                    </button>
                  </div>`;
                return fileLinks;
              },
              width: 100,
            },
            {
              field: "Name",
              title: "Name",
              width: 150,
            },
            {
              field: "Description",
              title: "Description",
              width: 150,
            },
            {
              field: "Report",
              title: "Report",
              width: 125,
            },
          ]}
          showOptions={true}
          showEdit={true}
          showDelete={true}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
          onDataBound={() => {
            $(".generate").on("click", function (e) {
              Generate(this);
            });
          }}
        />
      )}
      {refresh  != 0 && (
        <KendoGrid
          name={"CountonLeadReport"}
          schema={{}}
          url={url}
          refreshWhen={refresh}
          columns={[
            {
              field: "LeadName",
              title: "Lead Name",
              width: 150,
            },
            {
              field: "PrimaryContact",
              title: "Primary Contact",
              width: 150,
            },
            {
              field: "LeadStatus",
              title: "Lead Status",
              width: 125,
            },
            {
              field: "EventDate",
              title: "Event Date",
              width: 125,
            },
            {
              field: "StartTime",
              title: "Start Time",
              width: 100,
            },
            {
              field: "NoofAttendance",
              title: "No of Attendance",
              width: 150,
            },
            {
              field: "ReferralType",
              title: "Referral Type",
              width: 150,
            },
            {
              field: "FunctionType",
              title: "Function Type",
              width: 140,
            },
            {
              field: "FunctionTypeWebEv",
              title: "Function Type WebEv",
              width: 180,
            },
            {
              field: "Salesperson",
              title: "Sales person",
              width: 125,
            },
            {
              field: "RecBallroom",
              title: "Rec Ballroom",
              width: 150,
            },
            {
              field: "TourDate",
              title: "TourDate",
              width: 100,
            },
            {
              field: "Description",
              title: "Description",
              width: 150,
            },
          ]}
        />
      )}

      {Sms != 0 && (
        <KendoGrid
          name={"RingCentralSMSLogReport"}
          schema={{}}
          url={UrlSms}
          refreshWhen={Sms}
          columns={[
            {
              field: "Year",
              title: "Year",
              width: 150,
            },
            {
              field: "Month",
              title: "Month",
              width: 150,
            },
            {
              field: "Week",
              title: "Week",
              width: 125,
            },
            {
              field: "Quarter",
              title: "Quarter",
              width: 125,
            },
            {
              field: "Date",
              title: "Date",
              width: 100,
            },
            {
              field: "Type",
              title: "Type",
              width: 150,
            },
            {
              field: "FromNumber",
              title: "FromNumber",
              width: 150,
            },
            {
              field: "ToNumber",
              title: "ToNumber",
              width: 140,
            },
            {
              field: "ToName",
              title: "ToName",
              width: 180,
            },
            {
              field: "ReadStatus",
              title: "ReadStatus",
              width: 125,
            },
            {
              field: "MessageStatus",
              title: "MessageStatus",
              width: 150,
            },
          ]}
        />
      )}

      {callLog != 0 && (
        <KendoGrid
          name={"RingCentralCallLogsReport"}
          schema={{}}
          url={UrlForCallLog}
          refreshWhen={callLog}
          columns={[
            {
              field: "Year",
              title: "Year",
              width: 150,
            },
            {
              field: "Month",
              title: "Month",
              width: 150,
            },
            {
              field: "Week",
              title: "Week",
              width: 125,
            },
            {
              field: "Quarter",
              title: "Quarter",
              width: 125,
            },
            {
              field: "Date",
              title: "Date",
              width: 100,
            },
            {
              field: "DurationMs",
              title: "DurationMs",
              width: 150,
            },
            {
              field: "Type",
              title: "Type",
              width: 150,
            },
            {
              field: "PhoneNo",
              title: "PhoneNo",
              width: 140,
            },
            {
              field: "Name",
              title: "Name",
              width: 180,
            },
            {
              field: "Result",
              title: "Result",
              width: 125,
            },
          ]}
        />
      )}

      {CS != 0 && (
        <KendoGrid
          name={"CustomersatisficationReport"}
          schema={{}}
          url={UrlCS}
          refreshWhen={CS}
          columns={[
            {
              field: "Id",
              filterable: false,
              hidden: true,
            },
            {
              field: "EventNumber",
              title: "Event No",
              width: 150,
            },
            {
              field: "Name",
              title: "Name",
              width: 125,
            },
            {
              field: "PhoneNumber",
              title: "Phone No",
              width: 125,
            },
            {
              field: "EmailID",
              title: "Email",
              width: 150,
            },
            {
              field: "Ratingpoint",
              title: "Stars",
              width: 65,
            },
            {
              template: function (e) {
                if (e.IsreferUs) {
                  return "Yes";
                }
                return "No";
              },
              field: "IsreferUs",
              title: "Refer Us",
              width: 150,
            },
            {
              template: function (e) {
                if (e.IsvisitAgain) {
                  return "Yes";
                }
                return "No";
              },
              field: "IsvisitAgain",
              title: "Visit Again",
              width: 105,
            },
            {
              field: "ReviewDate",
              title: "Review Date",
              template: "#= kendo.toString(new Date(ReviewDate), 'MM/dd/yyyy') #",
              width: 115,
            },
            {
              field: "Type",
              title: "Type",
              template:
                "#= '<div style=\"text-transform: capitalize;\">' + Type + '</div>' #",
              width: 150,
            },
            {
              field: "ReviewComments",
              title: "Comments",
              width: 300,
            },
          ]}
        />
      )}

      {/* <!-- Save and Update Filter Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update-Filter"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Updated Filter</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-update-filter" onSubmit={onSubmit}>
                <input type="hidden" name="Report" value={event.Report} />
                <input type="hidden" name="Filters" value={event.Filters} />
                <input type="hidden" name="FilterId" value={event.FilterId} />
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="Name"
                      defaultValue={event.Name}
                      placeholder="Name"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Name", e.target.value);
                      }}
                    />
                    {error.Name && <ErrorMsg text="Name is required" />}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">
                      Description<span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="Description"
                      defaultValue={event.Description}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Description", e.target.value);
                      }}
                    />
                    {error.Description && (
                      <ErrorMsg text="Description is required" />
                    )}
                  </div>
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button name={"Save"} />
                  <button
                    type="reset"
                    id="btn-reset"
                    style={{ display: "none" }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Save and Update Filter Modal --> */}
    </>
  );
}
